module.exports = __webpack_public_path__ + "img/ydd_android.44da0338.png";